<template>
  <div>
    <h1>TREATMENT GOALS</h1>
    <v-layout>
      <v-text-field v-model="name" solo label="Name"></v-text-field>
      <v-text-field style="margin-left: 10px;" v-model="surname" solo label="Surname"></v-text-field>
      <v-btn :disabled="(name != null && name != '') && (surname != null && surname != '') ? false : true" @click="createUser" text
        color="success">Add new user</v-btn>
    </v-layout>
    <v-layout>
      <v-text-field @input="seatchMethod" v-model="search" solo label="Search"></v-text-field>
    </v-layout>
    <v-layout v-if="zoom != null">
      <v-data-table v-if="zoom.length" :headers="[
        /* { text: 'NUMBER', value: 'id_playlist' }, */
        { text: 'ID', value: 'id' },
        { text: 'NAME', value: 'name' },
        { text: 'SURNAME', value: 'surname' },
        { text: 'EDIT', value: 'edit' },
        { text: 'DELETE', value: 'actions' },


      ]" :items="filteredZoom">
        <template v-slot:item.actions="{ item }">
          <v-btn @click="deleteItem(item)" text color="error">DELETE</v-btn>
        </template>
        <template v-slot:item.edit="{ item }">
          <v-btn @click="edit(item)" text color="info">Edit</v-btn>
        </template>
      </v-data-table>
      <v-dialog v-model="dialog" v-if="selected != null" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Updating
          </v-card-title>

          <v-card-text>
            <v-text-field v-model="selected.name" label="Name"></v-text-field>
          </v-card-text>
          <v-card-text>
            <v-text-field v-model="selected.surname" label="Surname"></v-text-field>
          </v-card-text>
          <v-card-text>
            <v-text-field solo label="Email" v-model="selected.email"></v-text-field>
          </v-card-text>
          <v-card-text>
            <vue-tel-input style="max-height: 48px; margin-bottom: 30px;" tabindex="0" class="vue-tel-input"
              id="phone-input" v-model="selected.phone" v-bind="bindProps" @validate="validPhone"
              @input="clearValidation" @open="onDropdownOpen(true)" @close="onDropdownOpen(false)">
              <template v-slot:arrow-icon>
                <span>{{ open ? '' : '' }}</span>
              </template></vue-tel-input>
            <div class="phone-alert" v-if="phoneError && selected.phone != ''">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w 3.org/1999/xlink" width="14px"
                height="14px" viewBox="0 0 14 14" version="1.1">
                <g id="surface1">
                  <path style="
                          stroke: none;
                          fill-rule: nonzero;
                          fill: rgb(84.313725%, 15.686275%, 15.686275%);
                          fill-opacity: 1;
                        "
                    d="M 14 7 C 14 10.867188 10.867188 14 7 14 C 3.132812 14 0 10.867188 0 7 C 0 3.132812 3.132812 0 7 0 C 10.867188 0 14 3.132812 14 7 Z M 14 7 " />
                  <path style="
                          stroke: none;
                          fill-rule: nonzero;
                          fill: rgb(90.196078%, 90.196078%, 90.196078%);
                          fill-opacity: 1;
                        "
                    d="M 6.34375 10.9375 L 7.65625 10.9375 L 7.65625 9.625 L 6.34375 9.625 Z M 6.34375 2.625 L 6.34375 8.3125 L 7.65625 8.3125 L 7.65625 2.625 Z M 6.34375 2.625 " />
                </g>
              </svg>
              <span>{{
        phoneErrorMsg
      }}</span>
            </div>
          </v-card-text>
          <v-card-text>
            <v-select
              label="Speciality"
              v-model="selected.speciality"
              :items="specialties"
              item-text="name"
              item-value="name"
            ></v-select>
          </v-card-text>
          <v-card-text>
            <label for="text_input">Text</label>
            <br>
            <textarea v-model="selected.text" id="text_input"
              style="width: 100%;border: 1px solid #383838;border-radius: 10px;"></textarea>
          </v-card-text>

          <v-card-text>
            <img style="object-fit: cover;" v-if="selected.image != null && selected.image != ''" :src="selected.image"
              width="100px" height="100px" />
            <input type="file" ref="fileInput" style="display: none" accept=".png, .jpeg, .jpg"
              @change="handleFileChange">
            <v-btn @click="openFileInput" text color="success">Add image</v-btn>
          </v-card-text>

          <v-divider></v-divider>


          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" flat @click="update">
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios';

export default {
  data() {
    return {
      name: null,
      surname: null,
      open: false,
      specialties: null,
      zoom: null,
      phoneErrorMsg: "",
      phoneError: null,
      phoneVerified: false,
      filteredZoom: null,
      search: '',
      selected: null,
      dialog: false,
      bindProps: {
        autoFormat: true,
        autoDefaultCountry: false,
        defaultCountry: "IL",
        validCharactersOnly: true,
        mode: "international",
        disabled: false,
        preferredCountries: ["IL", "US", "UA"],
        dropdownOptions: {
          showDialCodeInList: true,
          showFlags: true,
          width: "250px",
        },
        inputOptions: {
          showDialCode: true,
          autocomplete: "off",
          placeholder: "הזן מספר טלפון",
          required: true,
          type: "tel",
          name: "phone",
          maxLen: 25,
        },
      },
    }
  },
  methods: {
    onDropdownOpen(val) {
      this.open = val;
    },
    validPhone(event) {
      this.phoneError = false;
      this.phoneErrorMsg = "";
      this.phoneVerified = false;
      clearTimeout(this.timerPhone);
      this.timerPhone = setTimeout(() => {
        if (!event.valid && this.selected.phone != "+972") {
          this.phoneVerified = false;
          this.phoneError = true;
          this.phoneErrorMsg = "מספר הטלפון שגוי";
        } else if (event.valid) {
          this.phoneVerified = true;
          this.phoneError = false;
        }
      }, 100);
    },
    clearValidation() {

    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = async () => {
        const base64Data = reader.result;
        let obj = {
          image: base64Data,
          id: this.selected.id
        }
        await axios.post("/admin/zoom/updateImage", obj).then((res) => {
          // this.sync();
          this.selected.image = res.data.url;
        })

      };
      reader.readAsDataURL(file);
    },
    async update() {
      if (this.selected.name != null && this.selected.name != "" && this.selected.surname != null && this.selected.surname != "")
        await axios
          .post("/admin/zoom/update", this.selected).then(() => {
            this.sync();
            // this.selected.name = null;
            // this.selected.id = null,
            this.dialog = false;
          })
    },
    edit(item) {
      this.selected = Object.assign({}, item);
      this.dialog = true;
    },
    seatchMethod(val) {
      if (this.search == '') {
        this.filteredZoom = this.zoom.sort((a, b) => {
          const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
          const nameB = b.name.toUpperCase();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0; // Names are equal
        });
        ;;
      }
      else {
        this.filteredZoom = this.zoom.filter(element => {
          return (element.name + ' ' + element.surname).includes(this.search)
        });
      }
    },
    async createUser() {
      if (this.name != null && this.name != "" && this.surname != null && this.surname != "") {
        await axios
          .post("/admin/zoom/create", {
            name: this.name,
            surname: this.surname
          }).then(() => {
            this.sync();
            this.name = null;
            this.surname = null;
          })
      }
    },
    async deleteItem(item) {
      await axios
        .post("/admin/zoom/delete", item).then(() => {
          this.sync();
        })
    },
    async sync() {
      await axios
        .get("/admin/zoom/get").then((res) => {
          this.zoom = res.data.sort((a, b) => {
            const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
            const nameB = b.name.toUpperCase();

            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0; // Names are equal
          });

          this.filteredZoom = res.data.sort((a, b) => {
            const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
            const nameB = b.name.toUpperCase();

            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0; // Names are equal
          });
          ;;
        })
      await axios
        .get("/specialties").then((res) => {
          this.specialties = res.data.sort((a, b) => {
            const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
            const nameB = b.name.toUpperCase();

            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0; // Names are equal
          });
        });
    },
  },
  created() {
    this.sync();
  }
}
</script>
<style lang="scss" scoped></style>